import { render } from "./BulkDialogContractorRow.vue?vue&type=template&id=f5657328"
import script from "./BulkDialogContractorRow.vue?vue&type=script&lang=js"
export * from "./BulkDialogContractorRow.vue?vue&type=script&lang=js"
script.render = render

export default script
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QInput});
